import './style.scss'
import Lottie from "lottie-react"
import { CustomContainer, GridContainer } from "src/style"
import comingSoon from 'src/assets/gif/comingSoon.json'

export const ComingSoon: React.FC<any> = ({width, height, topMargin}) => {
    return (
        <GridContainer topMargin={topMargin || '3.5'}>
            <CustomContainer 
                width={width || '44.5'} height={height || '43.2'}
                className='coming-soon-gif-wrapper'
            >
                <Lottie animationData={comingSoon} loop={true}/>
            </CustomContainer>
        </GridContainer>
    )
}